import React, { Fragment, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import { CopyToClipboardInput } from 'site-modules/shared/components/copy-to-clipboard-input/copy-to-clipboard-input';

import './share-link-icon.scss';

export function ShareLinkIcon({ className = null, url = undefined, onModalOpen = noop, onModalClose = noop }) {
  const [isModalOpen, setModalOpen] = useState(false);

  function openModal() {
    setModalOpen(true);
    onModalOpen();
  }
  const closeModal = useCallback(() => {
    setModalOpen(false);
    onModalClose();
  }, [onModalClose]);

  if (!url) {
    return null;
  }

  return (
    <Fragment>
      <Button className="share-link-icon p-0" color="link" onClick={openModal}>
        <i className={classnames('icon-share3', className)} aria-hidden />
      </Button>
      <Modal isOpen={isModalOpen} toggle={closeModal}>
        <ModalHeader toggle={closeModal} className="text-gray-darker">
          Share link
        </ModalHeader>
        <ModalBody>
          <CopyToClipboardInput inputValue={url} />
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

ShareLinkIcon.propTypes = {
  url: PropTypes.string,
  onModalOpen: PropTypes.func,
  onModalClose: PropTypes.func,
  className: PropTypes.string,
};
